<template>
  <div class="wrapper d-flex justify-content-center">
    <div class="">
      <div class="mx-5">
        <div class="boxes text-center pb-3 mb-3">
          <h1 class="text-dark">List Aplikasi</h1>
          <p>Pilih untuk dapat melanjutkan Peluncuran.</p>
        </div>

        <div class="d-flex flex-column flex-md-row justify-content-center gap-4 pt-3 mb-5">
          <div style="width: 100%;max-width: 20em;margin: 0 auto;">
            <div class="text-center border bg-white shadow-lg p-5 menu-item" @click="action('portal')">
              <!-- <Icon class="display-3" style="color: orange;" :icon="['fa', 'newspaper']" /> -->
              <div class="px-4 pb-2">
                <img src="/img/icons/monitor.png" alt="logo" style="width: 100%;">
              </div>
              <h4 class="mt-3 fs-3" style="white-space: nowrap;">Portal</h4>
              <hr>
              <p class="fst-italic">Content Manajement System Portal 
                <!-- <span>Dinas Perindustrian dan Perdagangan</span> -->
              </p>
            </div>
          </div>
          <div style="width: 100%;max-width: 20em;margin: 0 auto;">
            <div class="text-center border bg-white shadow-lg p-5 menu-item" @click="action('satudata')">
              <!-- <Icon class="display-3" style="color: orange;" :icon="['fa', 'table-cells']" /> -->
              <div class="px-4 pb-2">
                <img src="/img/icons/filing-cabinet.png" alt="logo" style="width: 100%;">
              </div>
              <h4 class="mt-3 fs-3" style="white-space: nowrap;">Satudata</h4>
              <hr>
              <p class="fst-italic">Sistem Informasi Manajemen Satudata 
                <!-- <span>Dinas Perindustrian dan Perdagangan</span> -->
              </p>
            </div>
          </div>
        </div>
        <br>
        <div class="text-center py-5">
          <Link href="/" class="btn btn-info"><Icon :icon="['fa', 'arrow-left']" /> Kembali Ke Halaman Utama</Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    action(mode) {
      this.$inertia.post('/admin', {
        mode
      });
    }
  },
}
</script>

<style lang="scss">
@import '../../../css/bootstrap';
</style>

<style lang="scss" scoped>
.wrapper {
  overflow: auto;
  height: 100vh;
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  padding: 5em 0;
  background: #74ebd5;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #ACB6E5, #74ebd5);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #ACB6E5, #74ebd5);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.boxes {
  // padding: 3.5rem 2.5rem;
  // background: #fff;
  width: 100%;
}

.menu-item {
  border-radius: 0.5em;
  cursor: pointer;
  transition: transform .2s;
  /* Animation */
}

.menu-item:hover {
  transform: scale(1.15);
}

.form-control,
.input-group-text {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
}

.input-group-text {
  padding: 0.47rem 0.75rem;
  display: block;
  cursor: pointer;
}

.form-check-label {
  font-weight: normal;
}
</style>